import { Container } from '@cgs/wge';
import { SlotParams } from '../slot_params';
import { T_IGameParams } from '../../type_definitions';

export const REEL_POSITION_HELPER_TOKEN = Symbol('REEL_POSITION_HELPER_TOKEN');

export class ReelPositionHelper {
  public readonly reelCount: number;
  public readonly linesCount: number;

  constructor(container: Container) {
    const slotParams = container.resolve<SlotParams>(T_IGameParams);
    this.reelCount = slotParams.reelsCount;
    this.linesCount = slotParams.linesCount;
  }

  public getReelIndex(icon: number): number {
    return icon % this.reelCount;
  }

  public getLineIndex(icon: number): number {
    return Math.floor(icon / this.reelCount);
  }

  public getPosition(reel: number, line: number): number {
    return line * this.reelCount + reel;
  }
}
